import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\ProductPage\AiProductPageStyleAdditionController::__invoke
* @see Http/Controllers/Web/ProductPage/AiProductPageStyleAdditionController.php:25
* @route '/ai-products/generation/style-addition'
*/
const AiProductPageStyleAdditionController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AiProductPageStyleAdditionController.url(options),
    method: 'post',
})

AiProductPageStyleAdditionController.definition = {
    methods: ["post"],
    url: '/ai-products/generation/style-addition',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Web\ProductPage\AiProductPageStyleAdditionController::__invoke
* @see Http/Controllers/Web/ProductPage/AiProductPageStyleAdditionController.php:25
* @route '/ai-products/generation/style-addition'
*/
AiProductPageStyleAdditionController.url = (options?: RouteQueryOptions) => {
    return AiProductPageStyleAdditionController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\ProductPage\AiProductPageStyleAdditionController::__invoke
* @see Http/Controllers/Web/ProductPage/AiProductPageStyleAdditionController.php:25
* @route '/ai-products/generation/style-addition'
*/
AiProductPageStyleAdditionController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AiProductPageStyleAdditionController.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\ProductPage\AiProductPageStyleAdditionController::__invoke
* @see Http/Controllers/Web/ProductPage/AiProductPageStyleAdditionController.php:25
* @route '/ai-products/generation/style-addition'
*/
const AiProductPageStyleAdditionControllerForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: AiProductPageStyleAdditionController.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\ProductPage\AiProductPageStyleAdditionController::__invoke
* @see Http/Controllers/Web/ProductPage/AiProductPageStyleAdditionController.php:25
* @route '/ai-products/generation/style-addition'
*/
AiProductPageStyleAdditionControllerForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: AiProductPageStyleAdditionController.url(options),
    method: 'post',
})

AiProductPageStyleAdditionController.form = AiProductPageStyleAdditionControllerForm

export default AiProductPageStyleAdditionController